export default {
      id: "icon-plus-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }